import React from 'react';
import { Spin } from 'antd';
import { LoaderOverlay } from './styles';

const Loader = (): JSX.Element => {
  return (
    <LoaderOverlay>
      <Spin size='large' />
    </LoaderOverlay>
  );
};

export default Loader;
